import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=c81f6d5c&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=c81f6d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81f6d5c",
  null
  
)

export default component.exports